<template>
  <component v-if="component && option"
    :is="component"
    :locale="locale"
    :lang="lang"
    :shopItemId="shopItemId"
    :shopResponsive="shopResponsive"
    :uniqueId="uniqueId"
    :optionInfo="option"
    :class="{shopOptionItem: true, isSubOption: isSubOption, isActive: activeOptionId === option.uniqueId}"
    :isSubOption="isSubOption"
    :cartOptionData="cartOptionData" />
</template>

<script>
import ShopDetailOptions from '../Options'

export default {
  name: 'ItemOption',
  props: [
    'locale',
    'shopResponsive',
    'uniqueId',
    'shopItemId',
    'option',
    'activeOptionId',
    'isSubOption',
    'cartOptionData'
  ],
  components: {
    ShopDetailOptions
  },
  computed: {
    lang () {
      return this.$route.params.ln
    },
    loader () {
      if (!this.option) {
        return null
      }
      const optionModule = this.option.type.replace(/\b\w/g, l => l.toUpperCase())
      return () => import(`./${optionModule}.vue`)
    }
  },
  
  mounted () {
    this.loader()
      .then(() => {
        this.component = () => this.loader()
      })
      .catch(() => {
        this.component = null
      })
  },
  data () {
    return {
      component: null
    }
  },
  methods: {
  }
}
</script>
